<template>
     <div class="space-y-4 divide-y-1 divide-gray-200">
           
                <div class="">
                    <div class="relative">
                        <div class="flex items-center justify-between pr-12">
                            <label
                
                                role="label"
                                for="public-token"
                                class="relative pr-3 pb-[3px] text-sm font-medium leading-normal text-gray-700"
                            >
                                Public key
                            </label>

                            <span
                                class="pb-[3px] text-sm font-medium leading-normal text-green-500"
                                >Safe to share</span
                            >
                        </div>
                        <div class="flex items-center gap-2 mt-1">
                            <textarea
                            id="public-token"
                                ref="public-token"
                                style="resize: none"
                                rows="2"
                                readonly
                                class="block w-full rounded-[6px] border border-gray-300 bg-white pt-2 pb-2.5 pr-[22px] pl-3 text-base sm:text-sm leading-normal text-gray-800 placeholder-gray-400 shadow-sm transition duration-100 ease-in-out hover:bg-gray-50 focus:border-2 focus:border-gray-600 focus:pl-[11px] focus:pt-[7px] focus:pr-[21px] focus:pb-[9px] focus:outline-none md:w-full"
                                v-text="apiToken.token"
                                ></textarea>
                            <AtomicButton
                                class="relative"
                                color="white"
                                size="icon"
                                
                                @click="copyPublicKey"
                            >
                                <template #icon>
                                    <DocumentDuplicateIcon
                                        class="h-5 w-5 text-gray-400"
                                    />
                                </template>
                            </AtomicButton>
                        </div>

                        <transition
                            enter-active-class="transition duration-100 ease-out transform"
                            enter-from-class="scale-95 opacity-0"
                            enter-to-class="scale-100 opacity-100"
                            leave-active-class="transition duration-75 ease-in transform"
                            leave-from-class="scale-100 opacity-100"
                            leave-to-class="scale-95 opacity-0"
                        >
                            <Tooltip
                                v-if="copiedPublicKeySuccess"
                                class="absolute top-[-25px]"
                                style="left: 50%; transform: translate(-50%, 0)"
                            >
                                Copied to clipboard!
                            </Tooltip>
                        </transition>
                    </div>

                </div>

                <div class="pt-4">
                    <div class="relative">
                           <div
                        class="items-center relative flex rounded-[4px] bg-yellow-100 pb-[13px] pl-3.5 pr-6 pt-3"
                    >
                        <svg
                            class="shrink-0"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M8.25685 3.09898C9.02185 1.73898 10.9788 1.73898 11.7428 3.09898L17.3228 13.019C18.0728 14.353 17.1098 15.999 15.5808 15.999H4.41985C2.88985 15.999 1.92685 14.353 2.67685 13.019L8.25685 3.09898ZM10.9998 13C10.9998 13.2652 10.8945 13.5196 10.707 13.7071C10.5194 13.8946 10.2651 14 9.99985 14C9.73463 14 9.48028 13.8946 9.29274 13.7071C9.10521 13.5196 8.99985 13.2652 8.99985 13C8.99985 12.7348 9.10521 12.4804 9.29274 12.2929C9.48028 12.1053 9.73463 12 9.99985 12C10.2651 12 10.5194 12.1053 10.707 12.2929C10.8945 12.4804 10.9998 12.7348 10.9998 13ZM9.99985 4.99998C9.73463 4.99998 9.48028 5.10534 9.29274 5.29287C9.10521 5.48041 8.99985 5.73476 8.99985 5.99998V8.99998C8.99985 9.2652 9.10521 9.51955 9.29274 9.70709C9.48028 9.89462 9.73463 9.99998 9.99985 9.99998C10.2651 9.99998 10.5194 9.89462 10.707 9.70709C10.8945 9.51955 10.9998 9.2652 10.9998 8.99998V5.99998C10.9998 5.73476 10.8945 5.48041 10.707 5.29287C10.5194 5.10534 10.2651 4.99998 9.99985 4.99998Z"
                                fill="#D69E2E"
                            />
                        </svg>
                        <div class="pl-3.5 text-sm leading-normal">
                            <p class="font-medium text-yellow-800">
                               {{ secretKeySeen ? 'Secret key already viewed — regenerate to see a new one.' : 'Keep your secret key secure — it can only be viewed once.' }} 
                            </p>
                        </div>
                    </div>

                        <div class="mt-2 flex items-center justify-between">
                            <label
                
                                role="label"
                                for="public-token"
                                class="relative pr-3 pb-[3px] text-sm font-medium leading-normal text-gray-700"
                            >
                                Secret key
                            </label>

                            <span
                                class="pb-[3px] pr-12 text-sm font-medium leading-normal text-red-500"
                                >Never expose</span
                            >
                        </div>
                        <div class="flex items-center gap-2 mt-1">
                            <textarea
                            id="public-token"
                                ref="public-token"
                                style="resize: none"
                                rows="2"
                                readonly
                                class="block w-full rounded-[6px] border border-gray-300 bg-white pt-2 pb-2.5 pr-[22px] pl-3 text-base sm:text-sm leading-normal text-gray-800 placeholder-gray-400 shadow-sm transition duration-100 ease-in-out hover:bg-gray-50 focus:border-2 focus:border-gray-600 focus:pl-[11px] focus:pt-[7px] focus:pr-[21px] focus:pb-[9px] focus:outline-none md:w-full"
                                v-text="secretKeyRevealed ? secretKey : secretKey.replace(/./g, '•')"
                                ></textarea>

                            <AtomicButton
                                class="relative"
                                color="white"
                                size="icon"
                                    :disabled="!secretKeyRevealed"
                                @click="copySecretKey"
                            >
                                <template #icon>
                                    <DocumentDuplicateIcon

                                        class="h-5 w-5 text-gray-400"
                                    />
                                </template>
                            </AtomicButton>
                        </div>

                        <transition
                            enter-active-class="transition duration-100 ease-out transform"
                            enter-from-class="scale-95 opacity-0"
                            enter-to-class="scale-100 opacity-100"
                            leave-active-class="transition duration-75 ease-in transform"
                            leave-from-class="scale-100 opacity-100"
                            leave-to-class="scale-95 opacity-0"
                        >
                            <Tooltip
                                v-if="copiedSecretKeySuccess"
                                class="absolute top-[30px]"
                                style="left: 50%; transform: translate(-50%, 0)"
                            >
                                Copied to clipboard!
                            </Tooltip>
                        </transition>
                    </div>

                    <div class="flex items-center gap-2">


                        <AtomicButton
                           class="relative mt-5"
                           color="white"
                           size="icon"
                           :disabled="secretKeyRevealed || secretKeySeen"
                           @click="revealSecretKey"
                       >
                           <template #icon>
                               <EyeIcon
                               v-if="!secretKeyRevealed"
                                   class="h-5 w-5 text-gray-400"
                               />
   
                               <EyeSlashIcon
                                   v-if="secretKeyRevealed"
                                   class="h-5 w-5 text-gray-400"
                               />
                           </template>
                       </AtomicButton>
   
                       <AtomicButton
                           class="relative mt-5"
                           color="white"
                           size="md"
                           :disabled="regenerating"
                           @click="regenerateSecretKey"
                       >
                           <template #icon>
                               <ArrowPathIcon
                                   class="h-5 w-5 mr-2 text-gray-400"
                               />
                           </template>
                           Regenerate secret key
                       </AtomicButton>
                    </div>
                </div>
            </div>
            </template>


<script lang="ts" setup>
import IToken from '@/types/Plugin/IToken';
import { ArrowPathIcon, DocumentDuplicateIcon, EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/outline';
import { useClipboard } from '@vueuse/core';
import { PropType, ref } from 'vue';

defineEmits(['close']);

const props = defineProps({
    apiToken: {
        type: Object as PropType<IToken>,
        required: true,
    }
});

onMounted(() => {
    fetchSecretKeySeen();
});

const clipboard = useClipboard();
const copiedPublicKeySuccess = ref(false);
const copiedSecretKeySuccess = ref(false);
const defaultSecretKey = 'e1sbRX0Mpx6FyhmM4KPx8c3xw2uCOSXnSUx7XRJ64s9gNB8XdeMKLJQ4xt';
const secretKey = ref(defaultSecretKey);
const secretKeyRevealed = ref(false);
const secretKeySeen = ref(false);
const regenerating = ref(false);

const copyPublicKey = () => {
    clipboard.copy(props.apiToken.token);

    copiedPublicKeySuccess.value = true;
    setTimeout(() => {
        copiedPublicKeySuccess.value = false;
    }, 1000);
};

const copySecretKey = () => {
    clipboard.copy(secretKey.value);

    copiedSecretKeySuccess.value = true;
    setTimeout(() => {
        copiedSecretKeySuccess.value = false;
    }, 1000);
};

const revealSecretKey = async () => {
    const secret = await fetchSecretKey();

    if (secret === null) {
        secretKeyRevealed.value = false;
        secretKey.value = defaultSecretKey;
    } else {
        secretKey.value = secret;
        secretKeyRevealed.value = true;
    }
}

const fetchSecretKeySeen = async () => {
    try {
        const res = await axios.get(route('api-tokens.secret-token.seen.show', {
            apiToken: props.apiToken.id
        }));

        secretKeySeen.value = res.data.seen;
    } catch (error) {
        console.error('Error fetching secret key seen status:', error);
    }
}

const fetchSecretKey = async () => {
    try {
        const res = await axios.get(route('api-tokens.secret-token.show', {
            apiToken: props.apiToken.id
        }));
        return res.data.secret;
    } catch (error) {
        console.error('Error fetching secret key:', error);
    }
}

const regenerateSecretKey = () => {

        router.post(route('api-tokens.secret-token.store', {
            apiToken: props.apiToken.id
        }), {}, {
            preserveState: true,
            preserveScroll: true,
            onStart: () => {
                regenerating.value = true;
            },
            onFinish: () => {
                regenerating.value = false;
            },
            onSuccess: () => {
                create({
                    title: 'Secret token regenerated',
                    text: 'Your secret token has been regenerated successfully.',
                    type: 'success',
                });

                secretKey.value = defaultSecretKey;
                secretKeyRevealed.value = false;

                fetchSecretKeySeen();
            },
        });
   }    
</script>